import React, { useState, useEffect } from "react";
import { Play, Filter, Calendar, Clock, AlertCircle } from "lucide-react";
import "../styles/VideosPage.css"; // Assure-toi que le fichier CSS est bien là

// Catégories pour le filtre (Tu pourras les dynamiser plus tard côté API)
const categories = ["Tous", "Actualités", "Juridique", "Tutoriels", "Vie de Quartier"];

const VideosPage = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("Tous");
  const [playingVideoId, setPlayingVideoId] = useState(null);

  // 1. Récupération des données API
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await fetch("https://api.nms06.com/api/videos");
        const data = await res.json();
        
        console.log("Données reçues :", data);

        if (Array.isArray(data)) {
          // On ajoute des fausses métadonnées si l'API ne les fournit pas encore
          // pour que le design reste joli
          const enhancedData = data.map(video => ({
            ...video,
            category: "Actualités", // Valeur par défaut
            date: "Récemment",      // Valeur par défaut
            duration: "Vidéo"       // Valeur par défaut
          }));
          setVideos(enhancedData);
        } else {
          console.error("Format de données incorrect :", data);
        }
      } catch (error) {
        console.error("Erreur API Vidéos :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  // 2. Filtrage (Si tu ajoutes des catégories dans ta base de données plus tard)
  const filteredVideos = activeCategory === "Tous" 
    ? videos 
    : videos.filter(v => v.category === activeCategory);

  return (
    <div className="videos-page">
      
      {/* --- HERO SECTION --- */}
      <div className="videos-hero">
        <div className="hero-content">
          <h1>La chaîne <span className="highlight">NMS 06</span></h1>
          <p>
            Retrouvez nos reportages, tutoriels juridiques et toute l'actualité 
            du quartier des Moulins en vidéo.
          </p>
        </div>
      </div>

      {/* --- FILTRES --- */}
      <div className="videos-filters-container">
        <div className="filters-scroll">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`filter-btn ${activeCategory === cat ? "active" : ""}`}
            >
              {activeCategory === cat && <Filter size={14} className="icon-active" />}
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* --- GRILLE VIDÉOS --- */}
      <div className="videos-grid">
        {loading ? (
          <div className="loading-state">Chargement des vidéos...</div>
        ) : filteredVideos.length > 0 ? (
          filteredVideos.map((video) => (
            <div key={video.youtubeVideoId || Math.random()} className="video-card">
              
              {/* Zone Média : Switch entre Image et Iframe */}
              <div className="video-media">
                {playingVideoId === video.youtubeVideoId ? (
                  <iframe
                    src={`https://www.youtube.com/embed/${video.youtubeVideoId}?autoplay=1`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="video-iframe"
                  ></iframe>
                ) : (
                  <div 
                    className="video-thumbnail-wrapper"
                    onClick={() => setPlayingVideoId(video.youtubeVideoId)}
                  >
                    {video.thumbnailUrl ? (
                      <img 
                        src={video.thumbnailUrl} 
                        alt={video.title} 
                        className="video-thumbnail" 
                      />
                    ) : (
                      <div className="no-thumbnail">
                         <img 
                            src={`https://img.youtube.com/vi/${video.youtubeVideoId}/maxresdefault.jpg`} 
                            alt="Fallback" 
                            className="video-thumbnail"
                         />
                      </div>
                    )}
                    
                    <div className="play-overlay">
                      <button className="play-button">
                        <Play size={32} fill="white" />
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Zone Infos */}
              <div className="video-info">
                <span className="video-category">{video.category}</span>
                <h3 className="video-title">{video.title}</h3>
                <div className="video-meta">
                  <span className="meta-item"><Calendar size={14} /> {video.date}</span>
                  {/* <span className="meta-item"><Clock size={14} /> {video.duration}</span> */}
                </div>
              </div>
              
            </div>
          ))
        ) : (
          <div className="no-videos">
            <AlertCircle size={48} />
            <p>Aucune vidéo disponible pour le moment.</p>
          </div>
        )}
      </div>

    </div>
  );
};

export default VideosPage;